import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet-async';
import ReactFlagsSelect from 'react-flags-select';

import { CiSearch } from 'react-icons/ci';
import { FaNairaSign } from 'react-icons/fa6';
import { IoMdAdd } from 'react-icons/io';
import { LuWallet } from 'react-icons/lu';
import { RiSendPlaneLine } from 'react-icons/ri';

import AddMoney from './AddMoney/AddMoney';
import AdminSupport from './Messages/AdminSupport';
import Cards from './Cards/Cards';
import ChatSpace from './Messages/ChatSpace';
import Dashboard from '../../components/Dashboard/Dashboard';
import Kyc from '../../components/ToDoActions/Kyc';
import KycModal from '../../components/UserActions/KycModal';
import Notifications from './Messages/Notifications';
import PaymentLinks from './Payments/PaymentLinks';
import RequestMoney from './Payments/RequestMoney';
import ScrollToTop from '../../hooks/ScrollToTop';
import SendMoney from './Payments/SendMoney/SendMoney';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import Transactions from './Transactions/Transactions';
import TransactionPin from '../../components/UserActions/TransactionPin';
import UserSettings from './Settings/UserSettings';
import UsernameAdd from '../../components/UserActions/UsernameAdd';
import Wallets from './Wallets/Wallets';
import ComingSoon from '../../components/ComingSoon/ComingSoon';
import LoadingScreen from '../../components/Loading/Loading';
import Leaderboard from '../Leaderboard/Leaderboard';

import BillCheck from '../../assets/img/icon/bill-check-broken.svg';
import coinSwap from '../../assets/img/icon/coins_swap.svg';
import dashboardAd from '../../assets/img/dashboard-ads.png';
import FilterIcon from '../../assets/img/icon/filter.svg';
import MapPennding from '../../assets/img/icon/map-pending.svg';
import MapSuccess from '../../assets/img/icon/map-success.svg';
import RequestMoneyIcon from '../../assets/img/icon/link.svg';
import withdrawIcon from '../../assets/img/icon/reverse-withdrawal.png';
import Converter from './Converter/Converter';
import SwapCurrency from './SwapCurrency/SwapCurrency';
import AddMoneySuccess from './AddMoney/AddMoneySuccess';
import WithdrawMoney from './Payments/WithdrawMoney/WithdrawMoney';
import TransactionDetails from './Transactions/TransactionDetails';
import AddMoneyFailed from './AddMoney/AddMoneyFailed';
import AddMoneyVerify from './AddMoney/AddMoneyVerify';
import SwapSuccess from './SwapCurrency/SwapSuccess';
import VerifyNumber from '../../components/UserActions/VerifyNumber';
import NotFound from '../NotFound/NotFound';
import { resendEmailOtp } from '../../api/auth';
import { toast } from 'react-toastify';
import SupportDetails from '../../components/AdminSupport/SupportDetails';
import WorkUpdate from '../../components/UserActions/WorkUpdate';
import ReferralDesign from './Referrals/Referrals';
import ReferralContests from './Referrals/ReferralContests';


function Home() {
    const isLoading = useSelector((state) => state.loading.isLoading);
    const navigate = useNavigate();
    const [selected, setSelected] = useState("NG");
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    // const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const userDetails = useSelector((state) => state.user.user);
    // const dashboardDetails = useSelector((state) => state.dashboard.dashboard);
    // console.log(userDetails);
    // console.log(dashboardDetails);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleCloseSidebar = () => {
        if (window.innerWidth <= 768) {
            setIsSidebarOpen(false);
        }
    };

    const getGreeting = () => {
        const hour = new Date().getHours();

        if (hour < 12) return `Good Morning 🌞`;
        if (hour < 18) return "Good Afternoon ☀️";
        return "Good Evening 🌙";
    };

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsSidebarOpen(false);
        }
    }, [location.pathname])

    return (
        <>
            <Helmet>
                <title>Dashboard | Cardplot</title>
            </Helmet>
            <main className="wrapper page-width">
                <ScrollToTop />

                <Sidebar userDetails={userDetails} isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                <div className={`main__content ${isSidebarOpen ? 'toggle__sidebar' : ''}`}>
                    <Routes>
                        <Route path='/dashboard' element={
                            <>
                                <TopNav title={getGreeting()} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <Dashboard />
                                </section>
                            </>
                        } />
                        <Route path='/add_money' element={
                            <>
                                <TopNav title={`Add money`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <AddMoney userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/add_money/success' element={
                            <>
                                <TopNav title={`Transaction Successful`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <AddMoneySuccess userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/add_money/failed' element={
                            <>
                                <TopNav title={`Transaction Unsuccessful`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <AddMoneyFailed userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/add_money/verify' element={
                            <>
                                <TopNav title={`Transaction Verification`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <AddMoneyVerify userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/converter' element={
                            <>
                                <TopNav title={`Currency Converter`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <Converter userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/transactions' element={
                            <>
                                <TopNav title={`Transactions`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <Transactions userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/transactions/:refId' element={
                            <>
                                <TopNav title={`Transactions`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <TransactionDetails userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/wallets' element={
                            <>
                                <TopNav title={`Wallets`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <Wallets userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/settings' element={
                            <>
                                <TopNav title={`Account`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <UserSettings />
                                </section>
                            </>
                        } />
                        <Route path='/cards/*' element={
                            <>
                                <Cards userDetails={userDetails} toggleSidebar={toggleSidebar} onClick={handleCloseSidebar} />
                            </>
                        } />
                        <Route path='/send_money/*' element={
                            <>
                                <SendMoney userDetails={userDetails} toggleSidebar={toggleSidebar} onClick={handleCloseSidebar} />
                            </>
                        } />
                        <Route path='/currency_swap' element={
                            <>
                                <TopNav title={`Swap Currency`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <SwapCurrency userDetails={userDetails} />
                            </>
                        } />
                        <Route path='/currency_swap/success' element={
                            <>
                                <TopNav title={`Swapping Successful`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <SwapSuccess userDetails={userDetails} />
                            </>
                        } />
                        <Route path='/request_money' element={
                            <>
                                <TopNav title={`Request Money`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <RequestMoney />
                                </section>
                            </>
                        } />
                        {/* <Route path='/withdraw_money' element={
                            <>
                                
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <WithdrawMoney />
                                </section>
                            </>
                        } /> */}
                        <Route path='/payment_links' element={
                            <>
                                <TopNav title={`Payment Links`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <PaymentLinks />
                                </section>
                            </>
                        } />
                        <Route path='/bill_payments' element={
                            <>
                                <TopNav title={`Airtime / Bill Payments`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <PaymentLinks />
                                </section>
                            </>
                        } />
                        <Route path='/chatspace' element={
                            <>
                                <TopNav title={`Chatspace`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <ChatSpace />
                                </section>
                            </>
                        } />
                        <Route path='/admin_support' element={
                            <>
                                <TopNav title={`Contact`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <AdminSupport userDetails={userDetails} />
                                </section>
                            </>
                        } />
                        <Route path='/admin_support/:ticketId' element={
                            <>
                                <TopNav title={`Ticket Details`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <SupportDetails />
                                </section>
                            </>
                        } />
                        <Route path='/notifications' element={
                            <>
                                <TopNav title={`Notifications`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <Notifications />
                                </section>
                            </>
                        } />
                        <Route path='/coming_soon' element={
                            <>
                                <TopNav title={`Coming Soon`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <ComingSoon />
                                </section>
                            </>
                        } />
                        <Route path='/referrals-and-earnings' element={
                            <>
                                <TopNav title={`Referrals & Earnings`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <ReferralDesign />
                                </section>
                            </>
                        } />
                        <Route path='/referral-contests' element={
                            <>
                                <TopNav title={`Referral Contest`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <ReferralContests />
                                </section>
                            </>
                        } />
                        <Route path='/contact' element={
                            <>
                                <TopNav title={`Contact Us`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar}>
                                    <ComingSoon />
                                </section>
                            </>
                        } />

                        <Route path="*" element={
                            <>
                                <TopNav title={`Page Not Found`} userDetails={userDetails} toggleSidebar={toggleSidebar} />
                                <section className="wrapper__content py-3 px-1" onClick={handleCloseSidebar} style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <NotFound inline={true} />
                                </section>
                            </>
                        } />
                    </Routes>
                </div>
            </main>
            <KycModal />
            <UsernameAdd />
            <TransactionPin />
            <VerifyNumber />
            <WorkUpdate />
        </>
    )
}

export default Home